export default "__VITE_ASSET__CqjEIKYH__"